/* angular:styles/component:css;1445fb9f288a1d989c4a9c002d1af361a2f26893654e9d45f452dcf522e70726;/app/src/app/shared/animations/labeled-text-field.component.ts */
label {
  margin-top: 24px;
}
input {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 14px 12px;
  border: solid 1px #c8c7cc;
  background-color: #fff;
  font-size: 13px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: none;
}
input:focus {
  border: solid 2px #61566e;
  color: #333;
}
/*# sourceMappingURL=labeled-text-field.component.css.map */
